import POShipmentDraftSearchType from './POShipmentDraftSearchTypes';

export const getShipmentDraftInfoListInProgress = () => {
  return { type: POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST };
};

export const getShipmentDraftInfoListInSuccess = (payload) => {
  return {
    type: POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST_SUCCESS,
    payload,
  };
};

export const getShipmentDraftInfoListListInFail = (payload) => {
  return {
    type: POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST_FAIL,
    payload,
  };
};

export const getShipmentDraftInfoListListInReset = () => {
  return {
    type: POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST_RESET,
  };
};

export const updateShipmentDraftInfoListRequest = (payload) => {
  return {
    type: POShipmentDraftSearchType.UPDATE_SHIPMENT_DRAFT_INFO_LIST_REQUEST,
    payload,
  };
};

export const updateShipmentDraftInfoCheckedItems = (payload) => {
  return {
    type: POShipmentDraftSearchType.UPDATE_SHIPMENT_DRAFT_INFO_LIST_CHECKED_ITEMS,
    payload,
  };
};

export const setShipmentDraftSearchExportModal = (payload) => {
  return {
    type: POShipmentDraftSearchType.SET_SHIPEMENT_DRAFT_SEARCH_EXPORT_TOGGLE,
    payload,
  };
};
